/*
    后台管理系统主路由组件
*/
import React,{Component} from 'react'
import { Layout} from 'antd';
import {Switch,Route} from 'react-router-dom'

import SiderMenu from '../../components/sider/sider'
import HeaderMenu from '../../components/header/header'
import OrderList from '../order-list/order-list'
import CompanyList from '../company/company-list'
import GoodsList from '../order-list/goods-list'
import DeviceList from '../order-list/device-list'
import DeviceListYg from '../order-list/device-list-yg'
import GpsDetail from '../order-list/gps-detail'
import GoodsAdd from '../goods-info/goods-add'
import GoodsInfoView from '../goods-info/goods-info-v'
import TrackList from '../order-list/track-list'
import TrackDetail from '../track-info/track-detail'
import KtTrackList from '../kt-track-info/kt-track-list'
import KtTrackInfo from '../kt-track-info/kt-track-info'
import KtTrackDetail from '../kt-track-info/kt-track-detail'
import MainPage from '../main-page/main-page'
import OrderInfo from '../order-info/index'
import OrderInfoView from '../order-info/index-v'
import KtOrderInfoView from '../kt-order-info/index-v'
import AddressList from '../address/address-list'
import DocList from '../order-list/doc-list'
import './main.less'
import KtOrderListTable from "../order-list/kt-order-list";
import KtOrderInfo from "../kt-order-info";
import RouteEdit from "../route/route-edit";
import RouteTableForm from "../route/route-table";
import UserSublist from "../subscribe/user-sublist.jsx";
const { Content,Footer} = Layout;

export default class Main extends Component{
    render() {
        return (
            <Layout style={{minHeight:'100%'}}>
                <SiderMenu/>
                <Layout>
                    <HeaderMenu/>
                    <Content
                        style={{
                            margin: '24px 16px',
                            padding: 24,
                            background: '#fff',
                            minHeight: 280,
                        }}
                    >
                            <Switch>
                                <Route path='/orderInfo' component={OrderInfo}/>
                                <Route path='/goodsAdd' component={GoodsAdd}/>
                                <Route path='/orderInfoView' component={OrderInfoView}/>
                                <Route path='/goodsList' component={GoodsList}/>
                                <Route path='/deviceListYg' component={DeviceListYg}/>
                                <Route path='/deviceList' component={DeviceList}/>
                                <Route path='/gpsDetail' component={GpsDetail}/>
                                <Route path='/goodsInfoView' component={GoodsInfoView}/>
                                <Route path='/home' component={MainPage}/>
                                <Route path='/TrackList' component={TrackList}/>
                                <Route path='/TrackDetail' component={TrackDetail}/>
                                <Route path='/ktTrackList' component={KtTrackList}/>
                                <Route path='/ktTrackInfo' component={KtTrackInfo}/>
                                <Route path='/ktTrackDetail' component={KtTrackDetail}/>
                                <Route path='/companyList' component={CompanyList}/>
                                <Route path='/kt-orders' component={KtOrderListTable}/>
                                <Route path='/kt-order' component={KtOrderInfo}/>
                                <Route path='/kt-order-view' component={KtOrderInfoView}/>
                                <Route path='/addressList' component={AddressList}/>
                                <Route path='/docList' component={DocList}/>
                                <Route path='/routes' component={RouteTableForm}/>
                                <Route path='/route/:id' component={RouteEdit}/>
                                <Route path='/route/' component={RouteEdit}/>
                                <Route path='/usersub' component={UserSublist}/>
                                <Route  component={OrderList}/>
                            </Switch>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}